import React from "react";
import PropTypes from "prop-types";
import styles from "./ExperiencesHome.module.css";

const SearchCategory = ({ title, trips, onTripClick, selectedTrip }) => {
  const listId = `${title.toLowerCase().replace(/\s+/g, '-')}-list`;
  return (
    <section aria-labelledby={`${listId}-title`}>
      <h2 id={`${listId}-title`} className={styles.categoryTitle}>{title}</h2>
      <div className={styles.searchList} aria-label={title}>
        <input
          type="text"
          list={listId}
          className={styles.hiddenInput}
          tabIndex={-1}
          aria-hidden="true"
        />
        <datalist id={listId}>
          {trips.map((trip) => (
            <option key={trip.id} value={trip.title} />
          ))}
        </datalist>
        {trips.map((trip) => (
          <button
            key={trip.id}
            type="button"
            className={styles.searchItem}
            onClick={() => onTripClick(trip)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onTripClick(trip);
              }
            }}
            aria-label={trip.title}
          >
            {trip.title}
          </button>
        ))}
      </div>
    </section>
  );
};

SearchCategory.propTypes = {
  title: PropTypes.string.isRequired,
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired,
  onTripClick: PropTypes.func.isRequired,
  selectedTrip: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};

SearchCategory.defaultProps = {
  selectedTrip: null
};

export default SearchCategory;
